<template>
  <div>
  
    
    <b-row >
       
  <!----- SideBar All Design List ---->
  <div class="qouteside">
    <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
  </div>
   
  <!----- SideBar All Design List End ----> 
  
     <div class="design-container-details__main" style="width:70%">
        <div class="brand-card brandcard" >

          <div class="col-md-12" style="margin-top:10px;margin-bottom:10px;">
             <div class="col-md-12">Design Title:<strong> &nbsp;{{style_details.design_title}}</strong> </div>
              <div class="col-md-12">Style Name : &nbsp;{{style_details.style_name}} >> {{style_details.sub_cattitle}}</div>
              <div class="col-md-12">Created Date : {{style_details.created_date }} </div>
              <div v-if="this.style_details.sendqname === null" class="col-md-12">Buyer Name : {{style_details.buyer_name }} </div>
              <div v-if="this.style_details.sendqname != null" class="col-md-12">Buyer Name : {{style_details.sendqname }} </div>
          </div>

<!-- Code For Tab -->
<navbarMenu :sampleCode="sampleStatuscode"></navbarMenu>
<br>

<!-- Code For Tab Ends -->
               <div class="col-md-12" style="padding-right: 20px;padding-left: 8px;">
                  <!-- <b-card  style="padding-top:10px;"> -->
                    <!-- <div class="col-md-12"> -->
                    <br>
                     <div class="col-md-10 float-right" style="margin-bottom:10px;" v-if="selected_status!='Approved' && user_type!='Fit_Technician'"> 
                      <router-link class="px-4 pull-right" :to="'/requested_quotation/' + route_id" >
                        <b-button type="submit" variant="primary" class="px-4 pull-right" v-if="(style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer')  || (style_details.assigned_to == null && user_type == 'Brand_Manager') || user_type == 'ME_USER'" v-bind:disabled="selected_design_status == 'Quote-Approved'">Request Quote</b-button>
                      </router-link>

                      <b-button type="submit" variant="primary" class="px-4 pull-right" v-if="((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'Brand_Manager')) && selected_operational_status == 'QuoteCreated'" v-bind:disabled="selected_operational_status == 'QuoteRecieved'" @click="modalEditSizeDetails">Edit Quote Details</b-button>
                     
                      <br>
                      <br>
                     </div><br><br>
                     <!--  <button v-b-modal.compaire-modal-xl type="button" class="btn btn-link"><i class="fa fa-newspaper-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Compaire Quotes</button> -->

                     <!-- Code Added For Filter -->


              <!-- <b-row class="col-md-10 ">
                <input type="hidden" name="isactiveId" id="isactiveId" value="">
                <input type="hidden" name="brand_title" id="brand_title" value="">
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                      <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions">
                          <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                          <option :value="false">Asc</option> <option :value="true">Desc</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>             
                       
              </b-row>  -->
             
                     <!-- Code Added For Filter Ends -->


                     <b-col md="9" class="float-right">
                       <!-- <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p> -->

                       <!-- Added Code for Compaire Quotes -->
                       
                       <!-- Added Code Ends -->
                      </b-col> 
                      <div class="col-md-2 float-right"> 
                      <p > <b>Total Records :<span style="color:red;">{{ quotation_count }}</span></b> </p>
                     </div><br><br>

                    <!-- <div class="col-md-12"> -->
                      <!-- <div class="col-md-12"> -->
                  <!-- <b-card  style="padding-top:10px;"> -->
                    <!-- <div class="col-md-12"> -->
                      <div class="col-md-12 " v-if="selected_count>0">
                        <div class="col-md-3 float-left">
                          <label><strong>Selected Quotes&nbsp;: &nbsp;</strong>{{selected_count}}</label>
                        </div>
                        <!-- v-if="selected_count>1" -->
                        <!-- <div class="col-md-3 float-left" >
                          <button @click="showcompairequotes();" class="btn btn-info"><span >Compare Quotes</span></button>
                        </div> -->
                      </div><br>
                     <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields1"  :current-page="currentPage" :perPage="perPage" :bordered="bordered" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
                       <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <!-- <template slot="selected" slot-scope="row" >
                       <b-form-group>
                           <input type="checkbox" v-if="row.item.status=='Submitted'" v-model="row.item.selected" v-on:click="getrowdata(row.item);checkselected($event, row.item);"/>
                       </b-form-group>
                    </template> -->

                    <template slot="total_amount" slot-scope="row" >
                      <span>{{(row.item.total_amount==="NaN" || row.item.total_amount===null || row.item.total_amount==='' || row.item.total_amount===undefined) ? 'NA' : row.item.total_amount}}</span>
                    </template>

                    <template slot="remarkaprrove" slot-scope="row">
                      <span v-if="row.item.status =='Approved'">{{row.item.remark}}</span>
                    </template>

                    <template slot="vendor_name" slot-scope="row" >
                      <div class="vendor_tooltip">{{row.item.vendor_name.substring(0,22)+".." }}<span class="tooltip_text">{{row.item.vendor_name}}
                        </span>
                      </div>
                    </template>
                    <template slot="action" slot-scope="row" v-if="row.item.status!='Requested'&& user_type !='Fit_Technician'">
                        <b-col md="12" class="pull-right text-right">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret v-if="selected_operational_status!='Approved'">
                          <template v-slot:button-content>
                            <button  style="border: none;" class="btn btn-link"><span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span></button>
                          </template>
                          <!-- <b-dropdown-item target="_blank" v-if="row.item.status == 'Approved' || row.item.status == 'Submitted' ">
                          <button type="button" class="btn btn-link" @click="openStatusUpdate(row.item.style_id, row.item.quote_id)"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Submitted Quote Details</button>
                        
                          </b-dropdown-item> -->

                          <b-dropdown-item target="_blank" v-if="row.item.status == 'Approved' || row.item.status == 'Submitted' ">
                          <button type="button" class="btn btn-link" @click="getrowdata(row.item, status='show')"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>
                          Submitted Quote Details</button>
                        
                          </b-dropdown-item>

                          <b-dropdown-item target="_blank" v-if="row.item.status != 'Approved' || row.item.status == 'Submitted' ">
                          <button type="button" class="btn btn-link" @click="getrowdata(row.item, status='edit')"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>
                          Edit Quote Details</button>
                        
                          </b-dropdown-item>

                         

                          <!-- <b-dropdown-item target="_blank" v-if="row.item.status=='Submitted' || row.item.status=='Negotiate'">
                          <button type="button" class="btn btn-link" @click="showEditQuoteModalshow(row.item, edit);"><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Edit Quote Details</button><br>

                          </b-dropdown-item> -->
                           <b-dropdown-item  class="ml-3" v-b-modal.modal-x  v-if="row.item.status == 'Approved' || row.item.status == 'Rejected' "> 
                              <span  
                              @click="showCommenteModal(row.item.comments, row.item.rejectcomments, row.item.status);"> 
                              <i title="View" class="fa fa-eye icons pointer" style="background-color: none; color: blue; width: 10px;"></i>View Comment

                                </span>
                      
                         </b-dropdown-item>
                          <!-- </b-dropdown-item> -->
                        </b-dropdown>
                      <!-- </div> -->
                        </b-col>
                    </template> 
                    <template slot="action" slot-scope="row" v-else-if="row.item.status=='Requested'"><div><label>--</label></div></template>       

                   
                    </b-table>
                <!-- </div> -->
             
                  <b-col md="6" class="my-1" v-if="quotation_count>0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="quotation_count"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col> 
               <!-- </div>  -->
               <!-- </div> -->
               <!-- </div>   -->
 </div>
    <!-- Code For Compaire Quotes Details Model -->
      <b-modal title="Quotes Details" id="compaire-modal-xl" size="xl" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" >

          <b-row class="col-md-12">
            
            <table style="border: 1px;">
              <thead>
                <tr>
                  <td>Cost Structure</td>
                  <td>Attributes</td>
                  <td>Vendor1</td>
                  <td>Vendor2</td>
                  <td>Vendor3</td>
                  <td>Vendor4</td>
                </tr>
              </thead>
              <tbody>
                <tr>Fabric 1 Cost</tr>
                <tr>Fabric Composition</tr>
                <tr>1</tr>
                <tr>1</tr>
                <tr>1</tr>
                <tr>1</tr>
              </tbody>
            </table>
            <b-col cols="8" >
              
               
              <div  class='col-md-12' >    
                  <b-form-group>
                    <b-col md="4" class="pull-left">
                     <label for="name"><b>Vendor Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.vendor_name}}
                   </b-col>
                  </b-form-group>

                 

                </div>  
               
            </b-col>
         
            
            <div slot="footer"  style="margin-top:20px;text-align:right" >
            
              <b-form-group
                  label="Style Name"
                  :label-cols="3" v-if="customer.status=='Submitted'">
                  <b-form-textarea rows="3" max-rows="6" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here...">
                  </b-form-textarea><br>
                  
                  <b-input-group class="mb-3" v-if="customer.status=='Submitted'">
                     
                      <label class="radio-inline"><input type="radio" name="optradio" value="Approved"  checked>&nbsp;Accept</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="Rejected" >&nbsp;Reject</label>&nbsp;&nbsp;
                      </b-input-group>
                                 
                </b-form-group>

            </div></b-row>
         </b-form>
      </b-col>

    </b-row>
    </b-modal> 
    <!-- Model ends for Quotes Compaire -->

            <!-- ~~~~~~~~~~~Modal for show comment -->
           <div>
            <b-modal id="modal-x" hide-footer   size="x" title="Comment" v-b-modal="isCommentModalVisible" @ok="isCommentModalVisible=false">
            
                <div class="row">
                    
                    
                    <div class="col-md-12 mb-4 text-center">
                        <!-- <b-button  variant="danger" style="float: right;" @click="submitquotecancel()" >
                      Cancel
                      </b-button> -->
                      <p v-if="selected_statusVendor == 'Approved'">{{comment}}</p>
                      <p v-if="selected_statusVendor == 'Rejected'">{{selected_rejectcomments}}</p>

                    </div>
                </div>

            <!-- Invoice -->
            </b-modal>
          </div> 

        <!-- ~~~~~~~~~~~~~~Modal end for comment -->




  <!-- Other Vendor reject comment modal -->
    <b-modal size="lg" title="Reason For Reject Vendor " v-model="rejectCommentModal" @ok="rejectCommentModal = false" v-if="this.items.length > 1">
        <b-form id="myform" @submit.prevent="submitVendorRejectComment()">
        

         <div class="row" v-for="(vendor, index) in selected_vendor_list " :key="vendor">
         <!-- this.selectedquote_id -->
         <!-- {{vendor.quote_id}}
         {{selectedquote_id}} -->
          <h5 class="text-dark" style="background-color:rgb(176,196,222)" v-if="selectedquote_id == vendor.quote_id  ">You are going to approve <b>{{vendor.vendor_name}}</b>. Rest all other will get rejected, please mention reason.</h5>
         </div>

         <div class="row">

         <div class="col-md-8" style="float-right" > </div>
          <div class="col-md-4" >
            <p>Same reason form all vendors <input type="checkbox" class="m-2" @click="(e) => showInput(e.target.checked)" />  </p> 
          </div>
        </div>

          <div class="row" v-for="(vendor, index) in selected_vendor_list " :key="vendor">
          <!-- <h5 class="text-danger" v-if="selectedQuoteID == vendor.quote_id  ">You are going to approve {{vendor.vendor_name}}. Rest all other will get rejected, please mention reason.</h5> -->

          <div class="col-md-7" >
            <p v-if="selectedquote_id != vendor.quote_id  ">{{vendor.vendor_name}}</p>
          </div>
 
          <div class="col-md-5" v-if="ischeckedAll == false">
        
            <input required="true" v-if="selectedquote_id != vendor.quote_id  " class="form-control" id="rejectcomment" name="rejectcomment" type="text" v-model="vendor.rejectcomment"  /> 
          </div>
          

           <div class="col-md-5"  v-if="ischeckedAll == true">
            <input required="true" v-if="selectedquote_id != vendor.quote_id  "  :disabled="index != 1" :autofocus="index == 1" class="form-control" id="rejectcomment1" name="rejectcomment1" type="text" v-model="rejectcomment1"  /> 
          </div>
          

      </div>

          <!-- <div v-if="ischeckedAll == true" v-for="(vendor, index) in selected_vendor_list " :key="vendor">
            <div class="col-md-7" >
              <p v-if="selectedQuoteID != vendor.quote_id  ">{{vendor.vendor_name}}</p>
            </div>

            <div class="col-md-5">
              <input type="text" v-model="inputText" placeholder="Enter text">
            <div ><input type="text" v-model="outputText">
            </div>
          </div>
        
          </div>
          -->
        


        
    
       <div class="row mt-4 text-right">
        <div class="col-md-8" ></div>
        <div class="col-md-2" >
          <button class="form-control btn btn-success" type="submit" >Submit </button>
        </div>
        <div class="col-md-2">
          <button class="form-control btn btn-danger" type="button" @click="cancelejectCommentModal()" >Cancel </button>
        </div>
        </div>
    </b-form>
    </b-modal>

  <!--  Other Vendor reject comment modal -->

          <!-- </b-card> -->
            <!-- </div> -->
            <!-- Model for Compaire Quotes -->
              <b-modal size="xl" title="Compare Quotes" v-model="showcompairequotesModel" @ok="showcompairequotesModel = false" ><label style="font-size:17px ; overflow:auto ;"><b></b></label>
            <div  class='col-md-12' id="vendor_list_scroll">
             <table id="multiLevelTable compare_table"  class="table table-bordered" style="overflow:auto;">
    
        <thead  id="thead_style">
            <tr v-for="data in compaire_quotes">
             
                <th class="col-cost" id="th_style" v-for="heading in data">
                <td  id="td_style" >{{heading.label1}}</td>
                </th>
      
            </tr>
        
        </thead>
        <tbody id="tbody_style">    
            <tr v-for="data in compaire_quotes1" >
               <th class="col-cost" rowspan="4" id="th_style"> {{data[0].label1}}</th>

                <th class="col-att" id="th_style">{{data[0].label2}}</th>

                 <td  v-for="value in data[0].values" id="td_style"> {{value.val}}</td>
              </tr>
              <tr v-for="data in compaire_quotes2" >

                <th class="col-att" id="th_style">{{data[0].label3}}</th>
                
                <td  v-for="value in data[0].values" id="td_style"> {{value.val}}</td>
                 
              </tr>
              <tr v-for="data in compaire_quotes3" >
                  <th class="col-att" id="th_style">{{data[0].label3}}</th>

                  <td  v-for="value in data[0].values" id="td_style"> {{value.val}}</td>
                 
                </tr>
                <tr v-for="data in compaire_quotes4" >
                   <th class="col-att" id="th_style">{{data[0].label3}}</th>
                    <td  v-for="value in data[0].values" id="td_style"> {{value.val}}</td>
                 
                </tr>





                    <tr v-for="data1 in compaire_quoteFab1" >
             
               <th class="col-cost" rowspan="4" id="th_style">{{data1[0].label1}}</th>

                <th class="col-att" id="th_style">{{data1[0].label2}}</th>
                <td  v-for="value in data1[0].values" id="td_style"> {{value.val}}</td>
                 
              </tr>
              <tr v-for="data1 in compaire_quoteFab2" >
                <th class="col-att" id="th_style">{{data1[0].label3}}</th>

                <td  v-for="value in data1[0].values" id="td_style"> {{value.val}}</td>
             
              </tr>
                <tr v-for="data1 in compaire_quoteFab3" >
                   <th class="col-att" id="th_style">{{data1[0].label4}}</th>

                    <td  v-for="value in data1[0].values" id="td_style"> {{value.val}}</td>
                 
                </tr>
                <tr v-for="data1 in compaire_quoteFab4" >
                   <th class="col-att" id="th_style">{{data1[0].label2}}</th>

                     <td  v-for="value in data1[0].values" id="td_style"> {{value.val}}</td>
               
                </tr>
                <tr v-for="cost in compare_base_cost1">
                  <th style="background-color:#ADD8E6" class="col-cost" id="th_style"></th>
                   <th style="background-color:#ADD8E6" class="col-att" id="th_style">{{cost[0].label}}</th>

                   <td style="background-color:#ADD8E6" v-for="value in cost[0].values" id="td_style"> {{value.val}}</td>
                
                  
                </tr>
                <tr v-for="print_cost in compare_print_cost">
                   <th class="col-cost" rowspan="9" id="th_style">{{print_cost[0].label}}</th>
                    <th class="col-att" id="th_style">{{print_cost[0].label1}}</th>
                    <td  v-for="value in print_cost[0].values" id="td_style"> {{value.val}}</td>
                   
                </tr>

                 <tr v-for="embroidery in compare_embroidery">
                  
                    <th class="col-att" id="th_style">{{embroidery[0].label1}}</th>

                     <td  v-for="value in embroidery[0].values" id="td_style"> {{value.val}}</td>
                      
                </tr>

                 <tr v-for="misc in compare_misc">
                  
                    <th class="col-att" id="th_style">
                      {{misc[0].label1}}
                    </th>

                     <td  v-for="value in misc[0].values" id="td_style"> {{value.val}}</td>
                    
                </tr>

                <tr v-for="trims in compare_trims">
                  
                    <th class="col-att" id="th_style">{{trims[0].label1}} </th>

                    <td  v-for="value in trims[0].values" id="td_style"> {{value.val}}</td>
                   
                </tr>


                 <tr v-for="packaging in compare_packaging_trims">
                  
                    <th class="col-att" id="th_style">{{packaging[0].label1}}</th>
                      <td  v-for="value in packaging[0].values" id="td_style"> {{value.val}}</td>
                  
                </tr>

                 <tr v-for="packaging in compare_packaging">
                  
                    <th class="col-att" id="th_style">{{packaging[0].label1}}</th>
                      <td  v-for="value in packaging[0].values" id="td_style"> {{value.val}}</td>
                    
                </tr>

                <tr v-for="trans in compare_transportation">
                  
                    <th class="col-att" id="th_style">{{trans[0].label1}}</th>
                      <td  v-for="value in trans[0].values" id="td_style"> {{value.val}}</td>
                  
                </tr>

                <tr v-for="cm in compare_cm">
                  
                    <th class="col-att" id="th_style">{{cm[0].label1}}</th>
                     <td  v-for="value in cm[0].values" id="td_style"> {{value.val}}</td>
                    
                </tr>

               <tr v-for="remarks in compare_remarks">
                  
                    <th class="col-att" id="th_style"> {{remarks[0].label1}}</th>
                     <td  v-for="value in remarks[0].values" id="td_style"> {{value.val}}</td>
                     
                </tr>

                <tr v-for="cost in  compare_base_cost2">
                  <th style="background-color:#ADD8E6" class="col-cost" id="th_style"></th>
                   <th style="background-color:#ADD8E6" class="col-att" id="th_style">{{cost[0].label}}</th>
                    <td style="background-color:#ADD8E6" v-for="value in cost[0].values" id="td_style"> {{value.val}}</td>
                  
                </tr>

                <tr v-for="l_margin in compare_licence_margin">
                   <th class="col-cost" rowspan="2" id="th_style">{{l_margin[0].label}}</th>
                    <th class="col-att" id="th_style">{{l_margin[0].label1}}</th>
                          <td  v-for="value in l_margin[0].values" id="td_style"> {{value.val}}</td>
                    


                </tr>
        <tr v-for="margin in compare_margin">
                   <th  class="col-att" id="th_style">{{margin[0].label1}}</th>
                    <td  v-for="value in margin[0].values" id="td_style"> {{value.val}}</td>
                 
                  
                </tr>

               <tr v-for="total in compare_total">
                  <th style="background-color:#778899" class="col-cost" id="th_style"></th>
                   <th style="background-color:#778899" class="col-att" id="th_style">{{total[0].label}}</th>
                     <td style="background-color:#778899" v-for="value in total[0].values" id="td_style"> {{value.val}}</td>                  
                </tr>
                
               

            
        </tbody>
      
    </table>
       </div>            
              </b-modal>
            <!-- Model for Compaire Quotes Ends -->

            <!-- Cost sheet modal starts-->

            <b-modal id="showcomponetModel" hide-footer v-model="showcomponetModel" size="xl" title="COST SHEET" no-close-on-backdrop>
                <div class="text-right">
                      <b-button type="button" size="sm" class="mb-3" variant="secondary" v-if="quotation_status =='Submitted' || quotation_status =='Approved' " @click="downloadCostSheetExcel();"> Download Submitted Quote</b-button>
                  
                </div>
                 <!-- <b-modal id="modal-x" hide-footer   size="x" title="Comment" v-b-modal="showcomponetModel" @ok="showcomponetModel=false"> -->
                  <!-- <h6>{{styleDataSendTomodal.brand_title}}</h6> -->
                   <div class="row">
                   
                  <costsheet @childDataEvent="handleChildData" :styleDataSendTomodal="styleDataSendTomodal" :formstatus="formstatus" :showcomponetModel='showcomponetModel' :selectedquote_id='selectedquote_id' :selected_vendor_id='selected_vendor_id' :selected_style_id='selected_style_id'></costsheet>
                  </div>

                  <hr>
                  <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" v-if="formstatus == 'show'">
                    <div class="row mt-3">
                      <div class="col-md-12 mb-4 text-center" >
                        
                          <b-form-group v-if="selected_design_status == 'QuoteApprovalpending' && ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'Brand_Manager'))"
                              label="Comment"
                              :label-cols="3" >
                              <b-form-textarea rows="3" max-rows="6" maxlength="100" v-model="comment" type="text" name="comment"  
                                 placeholder="Enter Comment Here..." required>
                              </b-form-textarea><br>
                              <b-input-group class="mb-3">
                                  <label class="radio-inline"><input type="radio" name="optradio" value="Approved" id="Approved" @click="rejectOtherVendorModal()" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                                  <label class="radio-inline"><input type="radio" name="optradio" value="Rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                                  <label class="radio-inline"><input type="radio" name="optradio" value="Negotiate" v-model="status">&nbsp;Rework</label>                       
                      
                            </b-input-group>
                                
                                
                                              
                            </b-form-group>
                                <b-form-group style="text-align:left !important;" v-if="quotation_status =='Approved'">
                                <a style="color:blue; cursor:pointer"  @click="createOrdershitForQuote();" Download>Create Order Sheet</a>
                            
                            </b-form-group>
                            <div slot="footer" class="text-right">
                              <b-button type="button" size="sm" class="mr-4" variant="secondary" v-if="quotation_status =='Submitted' || quotation_status =='Approved' " @click="downloadCostSheetExcel();"> Download Submitted Quote</b-button>
                              <b-button type="submit" size="sm" class="mr-4" variant="primary" v-if="quotation_status =='Submitted' &&  ((style_details.assigned_to != null && user_type == 'Junior_Buyer') || (style_details.assigned_to == null && user_type == 'Buyer') || (style_details.assigned_to == null && user_type == 'Brand_Manager'))"> Update Status</b-button>
                              <b-button  size="sm" variant="danger" @click="closequotationmodel()">cancel</b-button>
                            </div>

                        </div>
                    </div>

                  </b-form>
                                <!-- <p>Child Data: {{ childData }}</p>
                  {{showcomponetModel}} -->
                  <!-- Render the ChildComponent and listen for the custom event -->
            </b-modal>
            <!-- Cost sheet modal ends -->


            <!-- Edit size details modal -->

            <b-modal id="showEditSizedetailsModal" v-model="showEditSizedetailsModal" size="xl" title="Edit Size Details">
              <editSizeDetails  @closeeditsizemodal="hadledcloseeditsizemodal" :showEditSizedetailsModal="showEditSizedetailsModal"> </editSizeDetails>
            </b-modal>
    
        </div>
      </div>
    </b-row>  

  </div>

  



   <!-- </div> -->


 
</template>


<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   import Datepicker from 'vuejs-datepicker'
   import VeeValidate from 'vee-validate'

    import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
    MultiSelect.Inject(CheckBoxSelection);
    Vue.use(MultiSelectPlugin);

   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
   import navbarMenu from './_navbarMenu.vue';
   import costsheet from "./costsheet.vue";
   import editSizeDetails from "./editSizeDetails.vue";

   Vue.use(VeeValidate);
   
   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
        navbarMenu,
         Datepicker,
         costsheet,
         editSizeDetails,
      },  

     data () {
       return {      
         addfile:false,
         showSideMenu:true,
         tabs: [
           'Calculator',
           'Shopping cart',
           'Charts'
         ],
         quotationAddModal: false,
         msgRows: 0,
         addfile:false,
        quateitemlist:[],
        design_title:'',
        design_id:'',  
         design_date: '', 
        comment:'',  
        isCommentModalVisible: false, 
         
        collection_title:'', 
        imgpath:'',
        totalRows: 0,
        quote_date :'',
        quote_quantity :'',
        quote_currency :'',
        quote_prce_per :'',
        price_per_garment : '',
        quote_status :'',
        quote_unit : '',
        quantity :'',
        visible : true,
          list: [],
          messagedata: [],
          selectedId: 0,
          txtInput: '',
       title:'',
       design_no:'', 
       uploadfilemodel:false,
        quote_tab:false,
        message_tab: false,
        files_list:[],
        nav_design_list :[],
        catselected: '',
        subcatselected:'',
        cat_title: '',
        sub_cat_title:'',

        file_title:'',
        file_category:'',
        file_url_path:'',
        file_Category_options: [
          
          { value: 'Technical Pack', text: 'Technical Pack' },
          { value: 'Fabric', text: 'Fabric' },
          { value: 'Constructions', text: 'Constructions' },
          
        ],

        //Code for sampling
        requestSampleModal: false,
        requestedlisting:[],

        selectedDate: new Date(),
        
        sample_data: [],
        
        //Sampling code ends
           
        files_fields: [
          { key:'file_name', label: 'Files'},
          { key: 'category_name', label: 'Catagary'  },
          { key: 'uploaded_by', label: 'Uploaded_By'},          
          { key: 'created_date', label: 'Date' },    
          { key: 'download', label: 'Download' },    
         ],


      quoteunit: [
        { value: 'INR', text: 'INR' }
        
      ],
   
         activeTab: 1,
         //New Added code
         selectedVendor:[],
         options: [],
         showSelectAll : true,
         allowCustomValue : true,
         agentmaster : [],
         agentfields: { text: 'name', value: 'id' },
         created_date:'',
         customer: {},
          selected: "selected",
          isHidden: true,
          showDetails: true,
          quotationdetailsmodel:false,
         //New Added Code Ends

         
            remark: '',
            selectedage: null,
            delivery_date:'',
            submission_date:'',
            target_price: 0,
            submissionDate: new Date(),
            requestedDate: new Date(),
            route_id: '',
            sub_catid:0,
            design_details:[],
            design_id:0,
            comment: '',
            showdesigndetails: false,
            showdesigndetails1: false,
            rejectCommentModal: false,
            items:[],
            selected_vendor_list:[],
            fields1: [
            { key: 'selected', label: 'Selected'},
            { key: 'vendor_name', label: 'Vendor Name', sortable: true, sortDirection: 'desc' },
            { key: 'quantity', label: 'Quantity', sortable: true},
            { key: 'target_price', label: 'Target Price', sortable: true},
            { key: 'total_amount', label: 'Closed Price'},
            { key: 'updated_date', label: 'Request Date'},
            { key: 'effective_date', label: 'Submitted Date'},
            { key: 'status', label: 'Status'},
            { key:'remarkaprrove', label: 'Remark'},
            { key: 'finalcost', label: 'Final Cost'},
            { key: 'action', label: 'Action' },
      
       ],

        fields2: [
              { key: 'vendor_name', label: 'Vendor Name'},
              { key: 'commentbox', label: 'Comment for rejection'},
              { key: 'update', label: 'Update Status'}
            ],

       selected_fileds: [
          { key: 'vendor_name', label: 'Vendor Name', sortable: true, sortDirection: 'desc' },
          { key: 'quantity', label: 'Quantity', sortable: true},
           { key: 'target_price', label: 'Target Price', sortable: true},
            { key: 'updated_date', label: 'Request Date' ,tdClass: 'nameOfTheClass'},
            { key: 'effective_date', label: 'Submitted Date'},
            { key: 'status', label: 'Status'}
      
       ],
       sortDesc: true,
      sortDirection: 'desc',
      perPage:  10,
      currentPage: 1,
      sortBy: null,
      filter: null,
      bordered: true,
      isBusy: false,
      vendor_name: '',
      quantity : 0,
      updated_date: '',
      status: '',
      effective_date: '',
      style_details: [],
      user_type: '',
      fileObj: [],
      tp_status: false,   
      measurementchart_status: false,
      bom_status: false,
      fileupload_status: false,
      consumtionDeatils: [],
      //total: 0,
      items1: [
        { FabricConsumtion:'',  Fabrictype:'', Weight:0,quantity: 0, price: 0 ,rateunit:'',Consumptionunit:'',},
        
      ],
      selected_items: [
        { FabricConsumtion:[],  Fabrictype:[], Weight:[], price: []}
        
      ],
      invoice_subtotal: 0,
      invoice_total: 0,
      invoice_tax: 5,
      total_cost: 0,
      final_cost: 0,
      print_cost: 0,
      embroidery: 0,
      misc: 0,
      cm: 0,
      overhead: 0,
      trims: 0,
      packaging_trims: 0,
      packaging: 0,
      transportation: 0,
      licensee_margin: 0,
      margin: 0,
      remark:'',
      percent_cost1:0, 
      percent_cost2:0, 
      total_final_cost: 0,
      btnDisable: false, 
      selected_vendor_id: 0,
      selectedquote_id: 0,
      selected_style_id:"",
      rateunit:'',
      Consumptionunit:'',
         selected_operational_status: '',
      selected_design_status:'',
      vendor_msg: '',
      selected_vendor_name: '',
      quotation_status: '',
      selected_brand_id: 0,
      selected_status: '',
      file_tab_status: false,
      all_files_uploaded: 0,
      quotation_count: 0,
      selected_count: 0,
      selected_data_arr: [],
      showcompairequotesModel: false,
      vendor_list: [],
      comparevalue:[],

      // compare_qoute variable define
      result:[],
      sampleStatuscode:0,
       compaire_quotes:{"heading":[]},
       // compaire_quotes1:{"Fabric_Cost1":[]},
        // compaire_quotes1:{"Fabric_Cost1":[]},
        compaire_quotes1:{"Fabric_Cost1":[{"label1":"","label2":"","values":[]}]},

        compaire_quotes2:{"Fabric_Cost1":[{"label1":"","label3":"","values":[]}]},
        compaire_quotes3:{"Fabric_Cost1":[{"label1":"","label3":"","values":[]}]},
        compaire_quotes4:{"Fabric_Cost1":[{"label1":"","label3":""}]},
        compaire_quoteFab1:{"calculateeditprofitmarginFabric_Cost2":[{"label1":"","label2":""}]},
        compaire_quoteFab2:{"Fabric_Cost2":[{"label1":"","label3":""}]},
        compaire_quoteFab3:{"Fabric_Cost2":[{"label1":"","label4":""}]},
        compaire_quoteFab4:{"Fabric_Cost2":[{"label1":"","label2":""}]},
        compare_base_cost1:{"Base_cost1":[{"label":""}]},
        compare_print_cost:{"other_estimates":[{"label":"","label1":"",}]},
        compare_base_cost2:{"Base_cost2":[{"label":"Base cost2","values":[{"val":400},{"val":500},{"val":450}]}]},
        compare_embroidery:{"other_estimates":[{"label":"","label1":""}]},
        compare_misc:{"other_estimates3":[{"label":"","label1":""}]},
        compare_trims:{"other_estimates":[{"label":"","label1":""}]},
        compare_packaging_trims:{"other_estimates":[{"label":"","label1":""}]},
        compare_packaging:{"other_estimates":[{"label":"","label1":""}]},
        compare_transportation:{"other_estimates":[{"label":"","label1":""}]},
        compare_cm:{"other_estimates":[{"label":"","label1":""}]},
        compare_remarks:{"other_estimates":[{"label":"","label1":""}]},
        compare_licence_margin:{"l_margin":[{"label":"","label1":""}]},
        compare_margin:{"margin":[{"label":"","label1":""}]},
        compare_total:{"Total":[{"label":""}]},

        // edit quote variables
        showEditQuoteModal: false,
        chkDisable:false,
        quote_id:'',
        style_id:'',
        vendor_id:'',
        selectedQuoteOrdersheetID:"",
        selectedQuoteID:"",
        details1:{},
        tempobj:{},
         rejectedVendorlist: [],
         rejectedVendorlist1:[],
        Obj:{},
        inputText:[],
        outputText:[],
        ischeckedAll: false,
        rejectcomment1:'',
        selected_rejectcomments:'',
        selected_statusVendor: '',
        styleDataSendTomodal:{},
        childData: '',
        showcomponetModel : false,
        formstatus: '',
         showEditSizedetailsModal: false,
         style_code: "",
         style_name: "",
         vendor_mail: "",
         vendor_name: "",
         quote_number:[],

      // compaire_quote4:{
      //   "heading":[{"label":"Cost Structure"},{"label":"Attribute"},{"label":"Vendor1"},{"label":"Vendor2"},{"label":"Vendor3"}],
      //   "Fabric_Cost1":[{"label":"Fabric_Cost1"},{"label":"Fabric Composition","values":[{"val":10},{"val":20},{"val":30}]},{"label":"Fabric Type","values":[{"val":50},{"val":60},{"val":70}]}],
      //    "Fabric_Cost2":[{"label":"Fabric Composition","values":[{"val":400},{"val":200},{"val":300}]},{"label":"Fabric Type","values":[{"val":80},{"val":90},{"val":130}]}]
      //  },

      //Payload start
//       {"compaire_quotes":{"heading":[{"label1":"Cost Structure"},{"label1":"Attribute"},{"label1":"Vendor1"},{"label1":"Vendor2"},{"label1":"Vendor3"},{"label1":"Vendor4"},{"label1":"Vendor5"},{"label1":"Vendor6"},{"label1":"Vendor7"}]},

//  "quotation_sub1_row1":{"Fabric_Cost1":[{"label1":"Fabric 1 Cost",
//   "label2":"Fabric Composition","values":[{"val":10},{"val":20},{"val":30}]}]},

// "quotation_sub1_row2":{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label3":"Fabric Type","values":[{"val":50},{"val":60},{"val":70}]}]},

//  "quotation_sub1_row3":{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label4":"weight","values":[{"val":40},{"val":20},{"val":30}]}]},

// "quotation_sub1_row4":{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label2":"Cost 1","values":[{"val":80},{"val":90},{"val":130}]}]},

//  "quotation_sub2_row1":{"Fabric_Cost2":[{"label1":"Fabric 2 Cost",
//   "label2":"Fabric Composition","values":[{"val":400},{"val":200},{"val":300}]}]},

// "quotation_sub2_row2":{"Fabric_Cost2":[{"label1":"Fabric 2 Cost",
//   "label3":"Fabric Type","values":[{"val":80},{"val":90},{"val":130}]}]},

// "quotation_sub2_row3":{"Fabric_Cost2":[{"label1":"Fabric 2 Cost","label4":"weight","values":[{"val":60},{"val":90},{"val":45}]}]},

// "quotation_sub2_row4":{"Fabric_Cost2":[{"label1":"Fabric 2 Cost","label2":"Cost 2","values":[{"val":100},{"val":300},{"val":200}]}]},

// "compare_base_cost1":{"Base_cost":[{"label":"Base cost1","values":[{"val":200},{"val":300},{"val":450}]}]},

// "compare_print_cost":{"other_estimates":[{"label":"Other Estimates","label1":"Print Cost","values":[{"val":100},{"val":300},{"val":200}]}]},

// "compare_embroidery":{"other_estimates":[{"label":"Other Estimates","label1":"Embroidery","values":[{"val":50},{"val":30},{"val":20}]}]},

// "compare_misc":{"other_estimates":[{"label":"Other Estimates","label1":"Misc","values":[{"val":40},{"val":35},{"val":60}]}]},

// "compare_trims":{"other_estimates":[{"label":"Other Estimates","label1":"Trims","values":[{"val":60},{"val":55},{"val":45}]}]},

// "compare_packaging_trims":{"other_estimates":[{"label":"Other Estimates","label1":"Packaging Trims","values":[{"val":70},{"val":65},{"val":85}]}]},

// "compare_packaging":{"other_estimates":[{"label":"Other Estimates","label1":"Packaging","values":[{"val":80},{"val":55},{"val":45}]}]},

// "compare_transportation":{"other_estimates":[{"label":"Other Estimates","label1":"Transportation","values":[{"val":"Air"},{"val":"Road"},{"val":"Water"}]}]},

// "compare_cm":{"other_estimates":[{"label":"Other Estimates","label1":"CM","values":[{"val":300},{"val":200},{"val":500}]}]},

// "compare_remarks":{"other_estimates9":[{"label":"Other Estimates","label1":"Remarks","values":[{"val":"Good"},{"val":"Average"},{"val":"Average"}]}]},

// "compare_base_cost2":{"Base_cost":[{"label":"Base cost2","values":[{"val":400},{"val":500},{"val":450}]}]},

// "compare_licence_margin":{"l_margin":[{"label":"Margins","label1":"License Margin","values":[{"val":78},{"val":80},{"val":70}]}]},

// "compare_margin":{"margin":[{"label":"Margins","label1":"Margin","values":[{"val":60},{"val":90},{"val":70}]}]},

// "compare_total":{"Total":[{"label":"Total","values":[{"val":500},{"val":900},{"val":700}]}]}


// }

// Payload end





      // compaire_quotes:{"heading":[{"label1":"Cost Structure"},{"label1":"Attribute"},{"label1":"Vendor1"},{"label1":"Vendor2"},{"label1":"Vendor3"},{"label1":"Vendor4"},{"label1":"Vendor5"},{"label1":"Vendor6"},{"label1":"Vendor7"}]},
         //Code For Quotation Details Ends
  // compaire_quotes1:{"Fabric_Cost1":[{"label1":"Fabric 1 Cost",
  // "label2":"Fabric Composition","values":[{"val":10},{"val":20},{"val":30}]}]},




  // compaire_quotes2:{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label3":"Fabric Type","values":[{"val":50},{"val":60},{"val":70}]}]},
  // compaire_quotes3:{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label4":"weight","values":[{"val":40},{"val":20},{"val":30}]}]},
  // compaire_quotes4:{"Fabric_Cost1":[{"label1":"Fabric 1 Cost","label2":"Cost 1","values":[{"val":80},{"val":90},{"val":130}]}]},

  // compaire_quoteFab1:{"Fabric_Cost2":[{"label1":"Fabric 2 Cost",
  // "label2":"Fabric Composition","values":[{"val":400},{"val":200},{"val":300}]}]},
// compaire_quoteFab2:{"Fabric_Cost2":[{"label1":"Fabric 2 Cost",
//   "label3":"Fabric Type","values":[{"val":80},{"val":90},{"val":130}]}]},
 // compaire_quoteFab3:{"Fabric_Cost2":[{"label1":"Fabric 2 Cost","label4":"weight","values":[{"val":60},{"val":90},{"val":45}]}]},
 // compaire_quotesFab4:{"Fabric_Cost2":[{"label1":"Fabric 2 Cost","label2":"Cost 2","values":[{"val":100},{"val":300},{"val":200}]}]},

// compare_base_cost1:{"Base_cost1":[{"label":"Base cost1","values":[{"val":200},{"val":300},{"val":450}]}]},

// compare_print_cost:{"other_estimates":[{"label":"Other Estimates","label1":"Print Cost","values":[{"val":100},{"val":300},{"val":200}]}]},

// compare_embroidery:{"other_estimates2":[{"label":"Other Estimates","label1":"Embroidery","values":[{"val":50},{"val":30},{"val":20}]}]},

// compare_misc:{"other_estimates3":[{"label":"Other Estimates","label1":"Misc","values":[{"val":40},{"val":35},{"val":60}]}]},

// compare_trims:{"other_estimates":[{"label":"Other Estimates","label1":"Trims","values":[{"val":60},{"val":55},{"val":45}]}]},

// compare_packaging_trims:{"other_estimates5":[{"label":"Other Estimates","label1":"Packaging Trims","values":[{"val":70},{"val":65},{"val":85}]}]},

// compare_packaging_trims:{"other_estimates6":[{"label":"Other Estimates","label1":"Packaging","values":[{"val":80},{"val":55},{"val":45}]}]},

// compare_estimate7:{"other_estimates7":[{"label":"Other Estimates","label1":"Transportation","values":[{"val":"Air"},{"val":"Road"},{"val":"Water"}]}]},

// compare_estimate8:{"other_estimates8":[{"label":"Other Estimates","label1":"CM","values":[{"val":300},{"val":200},{"val":500}]}]},

// compare_remarks:{"other_estimates9":[{"label":"Other Estimates","label1":"Remarks","values":[{"val":"Good"},{"val":"Average"},{"val":"Average"}]}]},

// compare_base_cost2:{"Base_cost2":[{"label":"Base cost2","values":[{"val":400},{"val":500},{"val":450}]}]},

// compare_margin:{"l_margin":[{"label":"Margins","label1":"License Margin","values":[{"val":78},{"val":80},{"val":70}]}]},

// compare_Margin2:{"l_margin2":[{"label":"Margins","label1":"Margin","values":[{"val":60},{"val":90},{"val":70}]}]},

// compare_total:{"Total":[{"label":"Total","values":[{"val":500},{"val":900},{"val":700}]}]},
//       compaire_quotes:[{fab_arr:{[{Fabric:'Fabric1_Cost'},
//               { 
//                 FabricConsumtion: 'Silk',
//                 Fabrictype: 'demo',
//                 Weight: 10,
//                 price:100
//               },
//       {Fabric:"Fabric1_Cost"},
//               { 
//                 FabricConsumtion: 'Silk',
//                 Fabrictype: 'demo',
//                 Weight: 10,
//                 price:100
//               }]}}
// ],
      // Quote:{ 
      //           FabricConsumtion: Silk,
      //           Fabrictype: demo,
      //           Weight: 10,
      //           price:100
      //         },
      // Quote:{ 
      //           FabricConsumtion: Silk,
      //           Fabrictype: demo,
      //           Weight: 10,
      //           price:100
      //         },

       }
     },
  created: function () {  

    if (!localStorage.userData) {
    localStorage.redirectUrl = window.location.href;
    // window.location.href = window.location.origin + '/login';
    window.location.href = window.location.origin + '/cams_login';
   } 
      this.getqutationdetails();
      this.getdesigndetail();
      
      this.route_id=this.$route.params.id; 
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      if(userData) 
      {
        this.quote_tab=true;
        this.message_tab=true;
      }


     },

  //   watch :{

  //     tempobj: { 
  //       handler(newValue, oldValue) {
  //         if(this.tempobj && (Object.keys(this.tempobj).length > 0)){
  //         this.tempobj['TOTAL GARMENT COST'].column3 = parseFloat(parseFloat(this.tempobj['BODY FABRIC PRICE'].column3) + parseFloat(this.tempobj['TRIM FABRIC PRICE'].column3) + parseFloat(this.tempobj['PRINTING ( IF APPLICABLE)'].column3) + parseFloat(this.tempobj['EBROIDERY ( IF APPLICABLE)'].column3) + parseFloat(this.tempobj['CMT'].column3) + parseFloat(this.tempobj['WASHING'].column3) + parseFloat(this.tempobj['OTHERS'].column3) + parseFloat(this.tempobj['TRIMS'].column3) + parseFloat(this.tempobj['ADDITIONAL TRIM ( ELASTIC/ BUTTON / LACE/ CORSAGE )'].column3) + parseFloat(this.tempobj['LABELS AND TAGS'].column3) + parseFloat(this.tempobj['LD POLY BAG'].column3) + parseFloat(this.tempobj['GPT'].column3) + parseFloat(this.tempobj['TRANSPORT'].column3)).toFixed(2)
  //         console.log(this.tempobj['TOTAL GARMENT COST'].column3);

  //         this.tempobj['FINAL COST'].column3 =  parseFloat(parseFloat(this.tempobj['TOTAL GARMENT COST'].column3) + parseFloat(this.tempobj['OVERHEAD CHARGES'].column3) + parseFloat(this.tempobj['PROFIT MARGIN'].column3)).toFixed(2);

  //         this.tempobj['OVERHEAD CHARGES'].column3 = parseFloat((parseFloat(this.tempobj['TOTAL GARMENT COST'].column3) * parseFloat(this.tempobj['OVERHEAD CHARGES'].column2)) / 100).toFixed(2);

  //         this.tempobj['PROFIT MARGIN'].column3 = parseFloat((parseFloat(this.tempobj['TOTAL GARMENT COST'].column3) * parseFloat(this.tempobj['PROFIT MARGIN'].column2)) / 100).toFixed(2);
          
  //         }
  //       },      
  //       deep: true    
  //     } 

  // },


     mounted: function() {

     },
      computed: {
        total() {
        return this.items1.reduce(
          (acc, item) => acc + item.price * item.quantity,
          0
        );
        
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields1
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },

       methods: { 
        checkselected: function(value, selected_data){
          if(value.target.checked==true){
            this.selected_count= this.selected_count+1;
            // this.selected_data_arr.push(selected_data.quote_id)
            this.selected_data_arr.push(""+selected_data.quote_id+"")
             console.log("IIIIIIIIIIIIIIIII",this.selected_data_arr)
          }
          else{
            this.selected_count= this.selected_count-1;
            this.selected_data_arr.pop(selected_data)
            console.log("eeeeeeeeee",this.selected_data_arr)
          }
          // alert(value);
        },
        showcompairequotes: function(){
          this.showcompairequotesModel=true
           document.getElementById("overlay").style.display = "block";
          var selected_quotes= this.selected_data_arr
          const compareObj={
            // quote_id: ["4384,4695,4828,4749,4750,4752,4754,4756,4755,4757,4759"]    
            // quote_id: ["4384","4695","4828","4750"] 
             quote_id: selected_quotes,   
          }
          // console.log("compareObj",compareObj);
          // return false;
        axios.post(`${CONSTANTS.API_URL}/compare_vendorquote`,compareObj)
      .then(response => {
         document.getElementById("overlay").style.display = "none";

        this.result = response.data
        console.log("Result", this.result);
        if (this.result.returnmsg === 'Successful') {
          //fabcost1
          this.compaire_quotes=this.result.returnvalue[0].header_labels[0];
          this.compaire_quotes1=this.result.returnvalue[0].quotation_sub1_row1[0];
          
           this.compaire_quotes2=this.result.returnvalue[0].quotation_sub1_row2[0];

           this.compaire_quotes3=this.result.returnvalue[0].quotation_sub1_row3[0];
           
            this.compaire_quotes4=this.result.returnvalue[0].quotation_sub1_row4[0];

            // fabcost2
            this.compaire_quoteFab1=this.result.returnvalue[0].quotation_sub2_row1[0];
            
               this.compaire_quoteFab2=this.result.returnvalue[0].quotation_sub2_row2[0];

               this.compaire_quoteFab3=this.result.returnvalue[0].quotation_sub2_row3[0];
                
               this.compaire_quoteFab4=this.result.returnvalue[0].quotation_sub2_row4[0];

               //Base cost
               this.compare_base_cost1=this.result.returnvalue[0].compare_base_cost1[0];
              
               this.compare_base_cost2=this.result.returnvalue[0].compare_base_cost2[0];

               // Other Estimate
               this.compare_print_cost=this.result.returnvalue[0].compare_print_cost[0];
                // console.log("compare_print_cost",this.compare_print_cost);
                this.compare_embroidery=this.result.returnvalue[0].compare_embroidery[0];

                  this.compare_misc=this.result.returnvalue[0].compare_misc[0];

                  this.compare_trims=this.result.returnvalue[0].compare_trims[0];

                  this.compare_packaging_trims=this.result.returnvalue[0].compare_packaging_trims[0];

                   this.compare_packaging=this.result.returnvalue[0].compare_packaging[0];

                  this.compare_transportation=this.result.returnvalue[0].compare_transportation[0];

                  this.compare_cm=this.result.returnvalue[0].compare_cm[0];

                  this.compare_remarks=this.result.returnvalue[0].compare_remarks[0];

                  //margin
                    this.compare_licence_margin=this.result.returnvalue[0].compare_licence_margin[0];
                    this.compare_margin=this.result.returnvalue[0].compare_margin[0];

                    this.compare_total=this.result.returnvalue[0].compare_total[0];
           
        }
      })
        },
        openStatusUpdate: function(style_id,quote_id){
          this.selectedQuoteOrdersheetID= style_id;
          this.selectedQuoteID = quote_id;
          this.status='';
          this.comment='';
          this.showdesigndetails1= true;
        },
                    // Function For Action on status
    updatestylestatus: function(comment,value) {
      document.getElementById("overlay").style.display = "block";
      
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id; 
        

      // alert(this.ischeckedAll)
      if (status != '') {
        if (this.ischeckedAll === false && this.rejectedVendorlist && this.rejectedVendorlist.length) {

          this.Obj = {
            quote_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments: comment,
            vendor_id: this.selected_vendor_id,
            vendor_rejected: this.rejectedVendorlist,
            id: this.selectedquote_id,
            is_check: ""
          }
        }
        else if (this.ischeckedAll === true && this.rejectedVendorlist && this.rejectedVendorlist.length) {
          this.Obj = {
            quote_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments: comment,
            vendor_id: this.selected_vendor_id,
            vendor_rejected: this.rejectedVendorlist,
            id: this.selectedquote_id,
            is_check: "True"
          }
        }

        else {
          this.Obj = {
            quote_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments: comment,
            vendor_id: this.selected_vendor_id,
            id: this.selectedquote_id
          }

        }


        // let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
        //   if (this.rejectedVendorlist1 && this.rejectedVendorlist1.length) {
        //     console.log("rejectedVendorlist1------------------------>", this.rejectedVendorlist1);
        //     console.log("brandName---------------->", brandName);
        //     let obj = {
        //       brand: brandName,
        //       vendorArr: this.rejectedVendorlist1,
        //     };

        //     axios.post(`${CONSTANTS.API_URL}/getVendorNameAndEmail`, obj)
        //       .then(response => {
        //         if (response.data.returnmsg === "Successful") {
        //           console.log(response.data.returnvalue);

        //           let emailObj = {
        //             style_code: this.style_code,
        //             style_name: this.style_name,
        //             vendor_email: this.vendor_mail,
        //             vendor_name: this.vendor_name,
        //             brand_name: brandName,
        //             designer_name: userInfo[0].full_name,
        //             vendor_details: response.data.returnvalue,
        //             quote_number:this.quote_number
        //           }
        //           // Add email triggers for design approval
        //           axios.post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
        //             .then((response) => {
        //               if (response.data.returnmsg === "Successful") {
        //                 this.$fire({
        //                   text: "Quote is approved..!",
        //                   type: "success",
        //                   timer: 30000,
        //                 });
        //               } else {
        //                 this.$fire({
        //                   text: response.data.returnvalue,
        //                   type: "warning",
        //                   timer: 30000,
        //                 });
        //               }
        //             })
        //             .catch((e) => {
        //               this.errors.push(e);
        //             });
        //         }
        //       });

        //   }


        axios.post(`${CONSTANTS.API_URL}/updatequotationstatus`, this.Obj)
          .then(response => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data
            if (this.result.returnmsg === 'Successful') {

              let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
              if (this.rejectedVendorlist1 && this.rejectedVendorlist1.length) {
                console.log("rejectedVendorlist1------------------------>", this.rejectedVendorlist1);
                console.log("brandName---------------->", brandName);
                let obj = {
                  brand: brandName,
                  vendorArr: this.rejectedVendorlist1,
                };
                
                axios.post(`${CONSTANTS.API_URL}/getVendorNameAndEmail`, obj)
                  .then(response => {
                    if (response.data.returnmsg === "Successful") {
                      console.log(response.data.returnvalue);

                      let emailObj = {
                        quote_status: status,
                        style_code: this.style_code,
                        style_name: this.style_name,
                        vendor_email: this.vendor_mail,
                        vendor_name: this.vendor_name,
                        brand_name: brandName,
                        designer_name: userInfo[0].full_name,
                        vendor_details: response.data.returnvalue,
                        quote_number: this.quote_number,
                        // buyer_name:this.buyer_name,
                        // buyer_email:this.buyer_email
                        user_id: userInfo[0].user_id,

                      }
                      // Add email triggers for design approval
                      axios.post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                        .then((response) => {
                          if (response.data.returnmsg === "Successful") {
                            this.$fire({
                              text: "Email sent to vendor regarding quote..!",
                              type: "success",
                              timer: 30000,
                            });
                          } else {
                            this.$fire({
                              text: response.data.returnvalue,
                              type: "warning",
                              timer: 30000,
                            });
                          }
                        })
                        .catch((e) => {
                          this.errors.push(e);
                        });
                    }
                  });

              }

              else if (status && status === 'Negotiate') {

                let emailObj = {
                  quote_status: status,
                  style_code: this.style_code,
                  style_name: this.style_name,
                  vendor_email: this.vendor_mail,
                  vendor_name: this.vendor_name,
                  brand_name: brandName,
                  designer_name: userInfo[0].full_name,
                  user_id: userInfo[0].user_id,
                }


                axios.post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                  .then((response) => {
                    if (response.data.returnmsg === "Successful") {
                      this.$fire({
                        text: "Status Updated Successfully & Quote is in negotiation..!",
                        type: "success",
                        timer: 30000,
                      });
                    } else {
                      this.$fire({
                        text: response.data.returnvalue,
                        type: "warning",
                        timer: 30000,
                      });
                    }
                  })
                  .catch((e) => {
                    this.errors.push(e);
                  });  
               }

              else {
                let emailObj = {
                        quote_status: status,
                        style_code: this.style_code,
                        style_name: this.style_name,
                        vendor_email: this.vendor_mail,
                        vendor_name: this.vendor_name,
                        brand_name: brandName,
                        designer_name: userInfo[0].full_name,
                        quote_number: this.quote_number,
                        vendor_details: [{
                          vendor_name: this.vendor_name,
                          email_id : this.vendor_mail
                        }],
                        user_id: userInfo[0].user_id,
                      }
                      // Add email triggers for design approval
                      axios.post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                        .then((response) => {
                          if (response.data.returnmsg === "Successful") {
                            this.$fire({
                              text: "Quote is approved and Email sent successfully to vendor regarding quote..!",
                              type: "success",
                              timer: 30000,
                            });
                          } else {
                            this.$fire({
                              text: response.data.returnvalue,
                              type: "warning",
                              timer: 30000,
                            });
                          }
                        })
                        .catch((e) => {
                          this.errors.push(e);
                        });
               }
                    // this.$fire({
                    //   text:"Status Updated Successfully",
                    //   type: "success",
                    //   timer: 30000
                    //         })
           
          // this.showdesigndetails1 = false;
          this.showcomponetModel = false;
          // router.go(0);
          this.getdesigndetail();
          this.getqutationdetails();
          

           //this.getqutationdetails();
          //this.getqutationdetails(); 
        }else {
         // alert("Please Check Status");
         this.$fire({
                      text:"Please Check Status",
                      type: "warning",
                      timer: 30000
                            })
          
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    }
    
    else{
      document.getElementById("overlay").style.display = "none";
      this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 120000
                      })
    }
         },


    // For comment in modal
        showCommenteModal(comment, rejectcomments,status)
        {
      
             this.comment=comment
             this.selected_rejectcomments = rejectcomments
             this.selected_statusVendor = status
             this.isCommentModalVisible = true
          
        }, 
    

    // commentcancel: function(){

    //   this.showdesigndetails1 = !this.showdesigndetails1;
    //   // this.isBusy = !this.isBusy;
    // },


    
        closequotationmodel(){
          this.showcomponetModel = !showcomponetModel 
          // this.showdesigndetails1 = !this.showdesigndetails1;
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      // filters: {
      //   currency(value) {
      //     return value.toFixed(2);
      //   }
      // },
      getrowdata(value,status) {
            // console.log("valuevaluevaluevalue",value)
            this.formstatus = status
            this.selected_vendor_id=value.vendor_id; 
            this.selected_vendor_name=value.vendor_name;
            this.selected_style_id = value.style_id
            this.vendor_list.push(value.vendor_name)
            this.selectedquote_id=value.quote_id;
            console.log(this.selectedquote_id)
            this.quotation_status=value.status;
            console.log("value.statusvalue.statusvalue.statusvalue.statusvalue.status",this.selectedquote_id)
            this.editquatedetailseModal();
     },

    editquatedetailseModal()
    {
    document.getElementById("overlay").style.display = "block";
    this.btnDisable = false;

    const Obj = {
              
            quote_id: this.selectedquote_id,
            vendor_id:this.selected_vendor_id,
              
              }

        axios.post(`${CONSTANTS.API_URL}/getQuoteDetailsForVendor`,Obj)
            .then(response => {
              document.getElementById("overlay").style.display = "none";
              this.result = response.data
              if (this.result.returnmsg === 'Successful') {
                this.style_code = this.result.returnvalue.style_code;
                this.style_name = this.result.returnvalue.style_name;
                this.vendor_mail = this.result.returnvalue.email_id;
                this.vendor_name = this.result.returnvalue.vendor_name;

                // this.selectedVendorId = this.result.returnvalue.vendor_id;
                this.detailsofCostsheet = JSON.parse(this.result.returnvalue.costsheet_details);
                this.showcomp(this.detailsofCostsheet, this.formstatus)
             
              }


            })
            .catch(e => {
              this.errors.push(e)
            })
    },


       /****** Function to design details ********/
       getdesigndetail: function () {
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
               this.style_details = this.result.returnvalue[0];
               this.buyer_name= this.style_details.buyer_name;
               this.buyer_email=this.style_details.buyer_mail;
            this.sampleStatuscode=this.style_details.status_code_number;
            this.selected_brand_id= this.style_details.brand_id;
            this.selected_style_id =this.style_details.style_id;
               this.selected_operational_status = this.style_details.operational_status;
               this.selected_design_status = this.style_details.design_status;
            this.fileObj = this.result.returnvalue[1].file_name;
            this.all_files_uploaded= this.result.returnvalue[0].all_files_uploaded;
            this.totalRows = this.result.returnvalue.length;
            for(var i=0;i<=this.totalRows;i++){
              if(this.style_details.status_code_number>=8){
                this.file_tab_status =true;
              }
            }
            this.displayvendorlist(this.selected_brand_id);
            for(var i=0; i<=this.fileObj.length;i++){
              var file_name = this.fileObj[i].category_name;
              if(file_name=='Techpack'){
                this.tp_status = true;
              }
              if(file_name=='Measurement Chart'){
                this.measurementchart_status = true;
              }
              if(file_name=='BOM'){

                this.bom_status = true;
              }
              if((this.tp_status == true) && (this.measurementchart_status ==true) && (this.bom_status == true)){
              this.fileupload_status = true;
            }
            }
            
            this.totalRows = this.result.returnvalue.length;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },


        opendesignModal(value) {
          this.customer.vendor_name = value.vendor_name;
          this.customer.quantity = value.quantity;
          this.customer.target_price = value.target_price;
          this.customer.updated_date = value.updated_date;
          this.customer.effective_date = value.effective_date;
          this.customer.status = value.status;

        this.showdesigndetails =true;
        
 },


    commentcancel: function(){
      this.showdesigndetails = !this.showdesigndetails;
    },
  


       /*******Function for Vendor List********/
      displayvendorlist: function(brand_id) {
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var recarr=[];
        var brand_id = brand_id
          recarr=this.selectedVendor;
          const Obj={
               brand_id: brand_id,
             // subcat_id:subcat_id,
              style_id: this.$route.params.id
          }
          // style_id->143
        //agentmaster
        axios.post(`${CONSTANTS.API_URL}/getvendorlist`,Obj)
          .then((result) => {
            document.getElementById("overlay").style.display = "none";
            if(result.body.returnmsg =='Successful'){


            this.vendor_msg = result.body.returnmsg;
            this.agentmaster = result.body.returnvalue;
             for(var i = 0; i < this.agentmaster.length; i++) {
              var vendoryagent2 = {
                  id: this.agentmaster[i].vendor_id
                }
                this.vendor_options.push(this.agentmaster[i].vendor_id);
                    
                }
          }
          else{
            this.vendor_msg=result.body.returnmsg;
          }

          })
          .catch((ex) => {
            console.log('error', ex)
          })
    },



    // Function For Quotation listing
  getqutationdetails: function () {

        document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      // if (userData) 
      // {
           var userInfo = JSON.parse(userData)
           this.vendor_id = userInfo[0].vendor_id; 

        
           const Obj = {
                style_id:this.$route.params.id
              }
           axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
               console.log(this.result.returnvalue);
               let temp = [];
               temp = this.result.returnvalue;
                // this.result.returnvalue.subscribe(countries => temp.push(countries));
              
               for (let i = 0; i < temp.length; i++) {
                 this.quote_number.push(temp[i].quote_id);
               }
               this.items = temp;
               this.isBusy = !this.isBusy;
               // this.totalRows = this.result.returnvalue.length;
               this.quotation_count = temp.length;
               for(var i=0;i<=this.quotation_count;i++)
               {
                  if(this.items[i].status=='Approved'){
                    this.selected_status = 'Approved'
                  }
               }
              

               
             }else {
              this.items =[];
              this.quotation_count=0;
              this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
         //}       

       },
    // Function For Quotation Listing Ends



        //Code For Quotation Details Ends
    quotationmodelcancel: function() {
      this.customer = {};
      this.quotationdetailsmodel = !this.quotationdetailsmodel;
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    // edit quote methods 

    // seteditparmModal: function(value) {
    //   this.style_id = value.style_id;
    //   this.quote_id=value.quote_id;
    //   this.vendor_id=value.vendor_id;
    // },

    calculateFinalTotal(total) {
         
      this.total_final_cost=parseFloat(parseFloat(total) +parseFloat(this.print_cost) +parseFloat(this.overhead) + parseFloat(this.embroidery) + parseFloat(this.misc) + parseFloat(this.cm) + parseFloat(this.trims) + parseFloat(this.packaging_trims) + parseFloat(this.packaging) + parseFloat(this.transportation) ).toFixed(2);
      if(this.total_final_cost>0)
      {
        var f1=this.total_final_cost;
        var f2=this.total_final_cost;
        this.percent_cost1=(f1/100)*this.licensee_margin;
        this.percent_cost2=(f2/100)*this.margin;
      }
      else
      {
        this.percent_cost1=0;
        this.percent_cost2=0;
      }
      
      this.total_final_cost=parseFloat(parseFloat(total) +parseFloat(this.print_cost) + parseFloat(this.overhead) + parseFloat(this.embroidery) + parseFloat(this.misc) + parseFloat(this.cm) + parseFloat(this.trims) + parseFloat(this.packaging_trims) + parseFloat(this.packaging) + parseFloat(this.transportation) +parseFloat(this.percent_cost1) + parseFloat(this.percent_cost2)).toFixed(2);
      
    },

    setconsumption(value,index)
    {
      this.items1[index].Consumptionunit=value;
      this.chkDisable=true;
    },

    addRow() {
      this.items1.push({ FabricConsumtion: '',  Fabrictype: '', Weight:'',quantity: '', price: '' ,Consumptionunit:'',rateunit:''});
    },

    deleteRow(index, invoice_product) {
      var idx = this.items1.indexOf(invoice_product);
      if (idx > -1) {
          this.items1.splice(idx, 1);
      }
      var cost =(invoice_product.price*invoice_product.quantity)
      this.total_final_cost=(this.total_final_cost)-(cost);
    },

    saveInvoice(sub) {

      this.$validator.validateAll(sub).then((result) => {
        if (result) {

          document.getElementById("overlay").style.display = "block";
          this.quotemodal=false;
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
          this.vendor_id = userInfo[0].vendor_id; 
        
          const Obj = {
            costsheet_details: JSON.stringify(this.tempobj),
            Vendorid: this.selected_vendor_id,
            quote_id:this.selectedquote_id,
            styleid:this.selected_style_id,
            Total:this.tempobj['FINAL COST'].column3,
            updated_by: userInfo[0].email_id,
          }

          axios.post(`${CONSTANTS.API_URL}/submitquotationdetails`,Obj)
            .then(response => {
              this.result = response.data
              document.getElementById("overlay").style.display = "none";
              if (this.result.returnmsg === 'Successful') {
                this.$fire({
                    text:"Quotation Details Saved Successfully ",
                    type: "success",
                    timer: 30000
                  })
                
                this.getqutationdetails();
                this.getdesigndetail();
                this.showEditQuoteModal = false;
              }
              else
              {
                this.$fire({
                    text:"Error Wise Sumbmiting Quotation. ",
                    type: "error",
                    timer: 30000
                  })

              }


            })
            .catch(e => {
              document.getElementById("overlay").style.display = "none";
              this.errors.push(e)
            })

        }
      })

    },

    createOrdershitForQuote:async function(){
      // alert(this.selectedQuoteOrdersheetID);
      document.getElementById("overlay").style.display = "block";
      const Obj= {
        style_id:this.$route.params.id
      }
        await axios.post(`${CONSTANTS.API_URL}/getorderlistexcel`,Obj,{responseType: "blob"})
      .then(response=>{
        console.log(response)
        var blob = new Blob([response.data], {type: response.headers["content-type"],});
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `ordersheet_report_${new Date().getTime()}.xlsx`;
        link.click();
        document.getElementById("overlay").style.display = "none";
      })
      .catch(error=>{
        console.log(error)
        document.getElementById("overlay").style.display = "none";
        this.$fire({
        text:"Error In Donwloading Excel!",
        type: "warning",
        timer: 30000
        })
      })
      
    },

    downloadCostSheetExcel:async function(){
      // alert(this.selectedQuoteOrdersheetID);
      document.getElementById("overlay").style.display = "block";
      const Obj= {
        quote_id:this.selectedquote_id
      }
        await axios.post(`${CONSTANTS.API_URL}/downloadCostSheetExcel`,Obj,{responseType: "blob"})
      .then(response=>{
        console.log(response)
        var blob = new Blob([response.data], {type: response.headers["content-type"],});
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Cost_Sheet_${new Date().getTime()}.xlsx`;
        link.click();
        document.getElementById("overlay").style.display = "none";
      })
      .catch(error=>{
        console.log(error)
        document.getElementById("overlay").style.display = "none";
        this.$fire({
        text:"Error In Donwloading Excel!",
        type: "warning",
        timer: 30000
        })
      })
   
   
     },


    showEditQuoteModalshow(value){
    this.showEditQuoteModal=true;
    },

    // calculateBodyFabricpriceEdited(){
    //   // alert(this.tempobj['GARMENT CONSUMPTION ( BODY)'].column3)
    //   this.tempobj['BODY FABRIC PRICE'].column3 = parseFloat(parseFloat(this.tempobj['FINAL FABRIC COST'].column1) * parseFloat(this.tempobj['GARMENT CONSUMPTION ( BODY)'].column3)).toFixed(2);
    // },

    // calculateTrimeFabricPriceEdited(){
    //   this.tempobj['TRIM FABRIC PRICE'].column3 = parseFloat(parseFloat(this.tempobj['FINAL FABRIC COST'].column2 )* parseFloat(this.tempobj['GARMENT CONSUMPTION ( TRIM FABRIC )'].column3)).toFixed(2);
    // },

    submitquotecancel() {
      this.showEditQuoteModal = !this.showEditQuoteModal;
    },

    // calculateeditoverheadcharges(){

    //    this.tempobj['OVERHEAD CHARGES'].column3 = parseFloat((parseFloat(this.tempobj['TOTAL GARMENT COST'].column3 ) * parseFloat(this.tempobj['OVERHEAD CHARGES'].column2)) /100).toFixed(2)
    // },

    // calculateeditprofitmargin(){

    //    this.tempobj['PROFIT MARGIN'].column3 = parseFloat((parseFloat(this.tempobj['TOTAL GARMENT COST'].column3 ) * parseFloat(this.tempobj['PROFIT MARGIN'].column2)) /100).toFixed(2)
    // },

      getqutationdetailscomment: function () {

        document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');

           var userInfo = JSON.parse(userData)
           this.vendor_id = userInfo[0].vendor_id; 

        
           const Obj = {
                style_id:this.$route.params.id
              }
           axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
        
               this.selected_vendor_list = this.result.returnvalue
               
             }else {
                this.selected_vendor_list = []
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
         //}       

       },

    rejectOtherVendorModal(){
      this.rejectCommentModal =  true;
      this.getqutationdetailscomment();
      console.log("Rejected")
      console.log(this.selected_vendor_list)
    },

    submitVendorRejectComment()
    {
      
      console.log("selected_vendor_list",this.selected_vendor_list.length)
       console.log("rejectedVendorlist",this.rejectedVendorlist.length)
       

      if(this.ischeckedAll == false){

         for (let i = 0; i < this.selected_vendor_list.length; i++) {
        
           let data = []
           let data1 = [];
        
            this.selected_vendor_list.map((item, index) => {
                let tempItem = {};
                
                (tempItem.rejectcomment = item.rejectcomment),
                  (tempItem.vendor_id = item.vendor_id),
                  data1.push(item.vendor_id);
                  data.push(tempItem);

            });

           this.rejectedVendorlist = data;
           this.rejectedVendorlist1 = data1;
          }

      }else{

         for (let i = 0; i < this.selected_vendor_list.length; i++) {
        
         let data = []
         let data1 = [];
            this.selected_vendor_list.map((item, index) => {
                let tempItem = {};
                
                (tempItem.rejectcomment = this.rejectcomment1),
                  (tempItem.vendor_id = item.vendor_id),
                  data1.push(item.vendor_id);
                  data.push(tempItem);

            });

           this.rejectedVendorlist = data;
           this.rejectedVendorlist1 = data1;
          }

      }

     
      this.rejectCommentModal =  false
      this.selected_vendor_list = []
      // this.rejectedVendorlist = []
      //  this.selected_vendor_list = []
       this.rejectcomment1 =""
      console.log("rejectedVendorlist",this.rejectedVendorlist.length)

      console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
      console.log( this.rejectedVendorlist)
      

    },

    cancelejectCommentModal(){
     
     document.getElementById("Approved").checked = false;
      this.rejectCommentModal =  false
       this.selected_vendor_list = []
       this.rejectcomment1 =""
       this.ischeckedAll = false;
    },


    showInput(checked){  
       this.ischeckedAll = checked; 
       if(this.ischeckedAll == true){
        this.rejectcomment1=''
      document.getElementById('rejectcomment').value = '';
      document.getElementById('rejectcomment').value = null;

       }else{
          // alert(checked)
        
          this.rejectedVendorlist = []
       }
     
    },


    showcomp(value, status){
    
    // alert(this.childData)
    this.formstatus = status
    this.styleDataSendTomodal = value
    this.showcomponetModel = true;
    
  },

   handleChildData(data) {
      // Handle the data received from the child component here
      this.childData = data;
      this.showcomponetModel = this.childData;
      // this.getqutationdetails();
    },

   modalEditSizeDetails()
   {
    this.showEditSizedetailsModal = true ;
   },

   hadledcloseeditsizemodal(data)
   {
      
      this.showEditSizedetailsModal = data
      
   }
  
   
     }
   };
</script>
<style>
   .short-div {
   height:55px;
   }


.quote-dropdowns .dropdown--accepted {
    border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns>.card {
    background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}
.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
    align-items: center;
    justify-items: center;
    justify-content: center;
    cursor: pointer;
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}
.f-sz-l {
    font-size: 15px;
}
.flex-col {
    flex-direction: column;
}
.flex, .flex-col {
    display: flex;
}
.f-w-semi-bold {
    font-weight: 600;
}
.f-sz-sm {
    font-size: 12px;
}
.f-w-semi-bold {
    font-weight: 600;
}   

.card .card__section {
    flex-grow: 1;
    box-shadow: inset 0 -1px 0 0 #e5e5e5;
    box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
    padding: 16px 32px;
}

.input-grp {
    width: 100%;
    margin-bottom: 16px;
}
.input-grp {
    margin-bottom: 10px!important;
}

.input-grp label {
    margin-bottom: 6px;
    color: #333340;
}

input[type=number], input[type=password], input[type=tel], input[type=text] {
    padding: 13px 12px;
    border-radius: 2px;
    border: 1px solid #bfbfbf;
}
.input-grp input, .input-grp label, .input-grp select {
    display: block;
    width: 100%;
}

.input-grp select:disabled {
    background-color: #ebebe4;
}
.input-grp select {
    background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
    background-position: right 8px top 6px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
    border: 1px solid var(--fill-green-dark);
    border-top: none;
    background-color: #e8fff5;
}

    #heading_data{
      /*border-radius: 15px 15px 0 0 !important;*/
      border-bottom: 0 !important;
      height: 57px;
      background-color: #0099FF;

    }
    .main_body1{
      width: 970px;
    }
   /*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
    .container{
      align-content: center;
    }
    .search{
      border-radius: 15px 0 0 15px !important;
      background-color: white !important;
      border:0 !important;
      color:white !important;
    }
    .search:focus{
         box-shadow:none !important;
          outline:0px !important;
    }
    /*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
      #type_msg:focus{
         box-shadow:none !important;
           outline:0px !important;
    }
    .send_btn{
      border:1 !important;
      border-color: #20a8d8;
      background-color: #4d94ff;
      cursor: pointer;
    }
    .search_btn{
      border-radius: #20a8d8 !important;
      border:0 !important;
      background-color: #20a8d8;
      cursor: pointer;
    }
    .contacts{
      list-style: none;
      padding: 0;
    }
    .contacts li{
      width: 100% !important;
      padding: 5px 10px;
      margin-bottom: 15px !important;
    }
    .user_img{
      height: 40px;
      width: 30px;
      border:1.5px solid #f5f6fa;
      margin-left: 10px;

    }
    .user_img_msg{
      height: 30px;
      width: 30px;
      border:1.5px solid #f5f6fa;
    
    }
  .text-span{
    background:blue;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
.text-span2{
    background:gray;
    border-radius:50%;
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
}
  .brand-card{
   border-radius:0px !important;
  }

     .sidebar{
   background: #17a2b8!important;
   width:50px !important;
   }

   .sidebar .sidebar-nav{
    width:50px !important;
   }
   .sidebar .nav{
    width:50px !important;
   }

   .main{
    margin-left:50px !important;
   }
   #rec_msg{    
    margin-left: 40%;
    position: absolute;
   }


/*** Tabb ***/
.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
}
.flex {
    display: flex;
}

.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 43px !important;
    padding: 12px 22px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border: 1px solid #63c2de;
    border-radius: 12px;
}
.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
} 



html, body {
  margin: 0
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color:white
}

/*Code For Quotation Details */
  .txt_heading{
    text-align: center;
    font-weight: bold;
  }
  .td2{
    width: 250px;
  }
  #final{
    background: #A9A9A9 !important;
  }
  .tablerow{
  width: 100px;
  height: 40px;
  padding-left: 0px;
  padding-right: 0px;
}

/*Code For Quotation Details Ends*/

/*Todays CSS*/
.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}

  #activeTitle{
  font-size: 14px;
}
.vendor_tooltip {
  position: relative;
  display: inline-block;
  /*border-bottom: 1px dotted black;*/
}

.vendor_tooltip .tooltip_text {
  visibility: hidden;
  width: 120px;
  background-color: #c8ced3  ;
  color: black  ;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.vendor_tooltip:hover .tooltip_text {
  visibility: visible;
}
 /*#th_style {
  background: #ECEFF1;
  position: sticky;
  top: 0; 
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}*/
#thead_style th{
   position: -webkit-sticky; 
  position: sticky;
  top: 0;
  z-index: 20;
  background: #ECEFF1;
  color: #FFF;
  text-align: left;
}
.col-cost{
  left:0;
  position: sticky;
  background: #ECEFF1;
}
.col-att{
  left:85px;
  position: sticky;
  background: #ECEFF1;
}
#compare_table{
  text-align: left;
  position: relative;
  border-collapse: collapse;
}
#vendor_list_scroll{
  max-height: 500px;
    overflow-y: scroll;
}
#td_style{
  border:none;
  text-align:center;
}
/*#thead_style th:first-child{
   left: 0;
   position: sticky;
  z-index: 1;
}*/
/*#tbody_style th{
   position: -webkit-sticky;
  position: sticky;
  
  left: 0;
 top:0;
  z-index: 2;
  background: #ECEFF1;
  border-right: 1px solid #ECEFF1;
}*/
/*display: flex;flex-wrap: wrap; position: relative;border-collapse: collapse;*/
.brandcard{
   border-radius:0px !important;
   padding-left: 10px !important;
  }

.quotecost{
    font-size:13px;
  }
.quoteheading{
  font-size:17px;
}
.quoteinput{
    width: 100px;
  }
@media (max-width: 1024px) and (min-width: 992px)
{
  .quoteheading{
  font-size:15px;
}
  .quotehead{
    font-size:12px;
  }
  .quoteinput{
    width: 64px;
  }
  .quoteprintcost,.quoteembro,.quotemisc,.quotetrim,.quotepacktrim,.quotepack,.quotetrans,.quotecm{
    width: 100px;
  }
  .quotecost{
    font-size:12px;
  }
  .subtotal{
    margin-left:100px;
  }
}
@media (max-width: 768px)
{
 /* .quotehead{
    font-size:10px;
  }
  .quoteinput{
    width: 50px;
  }
  .quotecost{
    font-size:9px;
  }*/
   .quoteheading{
  font-size:15px;
}
  .quotehead{
    font-size:10px;
  }
  .quoteinput{
    width: 64px;
  }
  .quoteprintcost,.quoteembro,.quotemisc,.quotetrim,.quotepacktrim,.quotepack,.quotetrans,.quotecm{
    width: 100px;
  }
  .quotecost{
    font-size:12px;
  }
  .subtotal{
    margin-left:100px;
  }
}
@media (max-width: 1040px)
{
 .qouteside{
  display:none;
 }
}
@media (max-width: 414px)
{
 .quoteheading{
  font-size:12px;
}
}
@media (max-width: 360px)
{
.brandcard {
    padding-left: 12px !important;
}
}
@media (max-width: 450px) and (min-width: 350px) 
{
  .brandcard {
    padding-left: 15px !important;
}
}

@media (max-width: 320px)
{
 .quoteheading{
  font-size:10px;
}
}
.costlisting tr{
  background: none !important;
}
.perkg input {
  border: none !important;
  background: none !important;
}


</style>
